import { render, staticRenderFns } from "./TransportWindow.vue?vue&type=template&id=61471520"
import script from "./TransportWindow.vue?vue&type=script&lang=js"
export * from "./TransportWindow.vue?vue&type=script&lang=js"
import style0 from "./TransportWindow.vue?vue&type=style&index=0&id=61471520&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports